// // constants
export const appConstants = {
  GET_HOTELDATA_REQUEST: "GET_HOTELDATA_REQUEST",
  GET_HOTELDATA_SUCCESS: "GET_HOTELDATA_SUCCESS",
  GET_HOTELDATA_FAILURE: "GET_HOTELDATA_FAILURE",
};
